export const CANCELLED = 'cancelled'
export const DELAYED = 'delayed'
export const SUSPENDED = 'suspended'
export const POSTPONED = 'postponed'
export const UPCOMING = 'upcoming'

export const isDisrupted = (liveStateId?: string) =>
  liveStateId
    ? [
      CANCELLED,
      DELAYED,
      SUSPENDED,
      POSTPONED,
    ].includes(liveStateId.toLowerCase())
    : false

export const isUpcoming = (liveStateId?: string) => liveStateId && Boolean(liveStateId.toLowerCase() === UPCOMING)
